export default __webpack_public_path__ + "static/media/Linux.62cd32f0.svg";